import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import constants from "../period-calculator-constants/OC_Constants";
import DatePicker from "react-datepicker";
import addDays from "date-fns/addDays";
import Customdatepicker from "../period-calculator-landing-page/Customdatepicker";
import { isMobile } from "react-device-detect";
import "react-datepicker/dist/react-datepicker.css";
import "../period-calculator-landing-page/PeriodLayout.css";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { registerLocale } from "react-datepicker";
import enIN from "date-fns/locale/en-IN";
registerLocale("enIN", enIN);

const currentdate = new Date();
const defaultview = true;

class FutureDateLastPeriodData extends React.Component {
  // Setting component default state here
  state = {
    cycleLengthValue: constants.DEFAULT_CYCLE_LENGTH, //Default value
    dayValue: new Date().getDate(), // used for default selected value in dropdown
    monthValue: new Date().getMonth(), // used for default selected value in dropdown
    yearValue: new Date().getFullYear(), // used for default selected value in dropdown,
    periodDuration: constants.DEFAULT_PERIOD_DURATION,
    isPeriodChange: false,
    isCycleChange: false,
    showPlus: false,
    showRangeSlider: false,
    dplabel: this.props.componentData.dateSelectionLabel.value,
    startDate: null,
    fromFutureDate: null,
    fromFutureEndDate: null,
    // monthtoshown: isMobile ? 1 : 2,
    currentDate: new Date(),
    lastPeriodDateLogo: this.props.parentCompData.datePickerLogo.value,
    copen: defaultview,
  };

  // This is LifeCycle method used to setup the default data for rendering
  componentDidMount() {
    // document.addEventListener('click', this.handleClickOutside);
    let {
      cycleLength,
      periodDuration,
      dayValue,
      monthValue,
      yearValue,
    } = this.props.currentMonthCycle;
    if (cycleLength === 0) cycleLength = 28;
    if (periodDuration === 0) periodDuration = 4;
    this.setState(
      (prevState, props) => {
        return {
          startDate: new Date(yearValue, monthValue, dayValue),
          cycleLengthValue: cycleLength,
          periodDuration: periodDuration,
          fromFutureDate: new Date(yearValue, monthValue, dayValue + 1),
          fromFutureEndDate: new Date(yearValue, monthValue, dayValue + 2),
        };
      },
      () => {
        this.props.sendLastPeriodData(
          this.state.dayValue,
          Number(this.state.monthValue),
          this.state.yearValue,
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          this.state.fromFutureDate,
          this.state.fromFutureEndDate
        );
      }
    );
  }

  componentDidUpdate(nextProps) {
    let {
      cycleLength,
      periodDuration,
      dayValue,
      monthValue,
      yearValue,
      reminderTime,
    } = this.props.currentMonthCycle;
    if (nextProps.selectedEvent !== this.props.selectedEvent) {
      this.setState(
        () => {
          return {
            startDate: new Date(yearValue, monthValue, dayValue),
            cycleLengthValue: cycleLength,
            periodDuration: periodDuration,
            fromFutureDate: new Date(yearValue, monthValue, dayValue + 1),
            fromFutureEndDate: new Date(yearValue, monthValue, dayValue + 2),
          };
        },
        () => {
          this.props.sendLastPeriodData(
            this.state.dayValue,
            Number(this.state.monthValue),
            this.state.yearValue,
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
      if (document.getElementById("calculate-period-button-id"))
        document.getElementById("calculate-period-button-id").disabled = false;
    }
  }

  increasePeriod = () => {
    if (this.state.periodDuration < 10) {
      this.setState(
        (prevState) => ({
          periodDuration: prevState.periodDuration + 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
    }
  };

  decreasePeriod = () => {
    if (this.state.periodDuration > 1) {
      this.setState(
        (prevState) => ({
          periodDuration: prevState.periodDuration - 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
    }
  };

  increaseCycle = () => {
    if (this.state.cycleLengthValue < 38) {
      this.setState(
        (prevState) => ({
          cycleLengthValue: prevState.cycleLengthValue + 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
    }
  };

  decreaseCycle = () => {
    if (this.state.cycleLengthValue > 21) {
      this.setState(
        (prevState) => ({
          cycleLengthValue: prevState.cycleLengthValue - 1,
          isPeriodChange: true,
        }),
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
    }
  };

  handleCalendarOpen = () => {
    if (this.state.copen) {
      this.setState({ copen: false });
    } else {
      this.setState({ copen: true });
    }
  };

  changeDate = (date) => {
    this.setState(
      (prevState, props) => {
        return { startDate: date, copen: false };
      },
      () => {
        this.props.sendLastPeriodData(
          new Date(date).getDate(),
          new Date(date).getMonth(),
          new Date(date).getFullYear(),
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          this.state.fromFutureDate,
          this.state.fromFutureEndDate
        );
      }
    );
    if (isMobile) {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 0);
    }
  };

  changeFromStartDate = (date) => {
    var nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + 1);
    if (this.state.fromFutureEndDate - date > 0) {
      this.setState(
        (prevState, props) => {
          return { fromFutureDate: date, copen: false };
        },
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
    } else {
      this.setState(
        (prevState, props) => {
          return {
            fromFutureDate: date,
            fromFutureEndDate: nextDate,
            copen: false,
          };
        },
        () => {
          this.props.sendLastPeriodData(
            new Date(this.state.startDate).getDate(),
            new Date(this.state.startDate).getMonth(),
            new Date(this.state.startDate).getFullYear(),
            this.state.cycleLengthValue,
            this.state.periodDuration,
            true,
            this.state.fromFutureDate,
            this.state.fromFutureEndDate
          );
        }
      );
    }

    // setTimeout(function(){ window.scrollTo(0, 0); }, 0);
  };

  changeFromEndDate = (date) => {
    this.setState(
      (prevState, props) => {
        return { fromFutureEndDate: date, copen: false };
      },
      () => {
        this.props.sendLastPeriodData(
          new Date(this.state.startDate).getDate(),
          new Date(this.state.startDate).getMonth(),
          new Date(this.state.startDate).getFullYear(),
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          this.state.fromFutureDate,
          this.state.fromFutureEndDate
        );
      }
    );
    // setTimeout(function(){ window.scrollTo(0, 0); }, 0);
  };

  handleCalendarClose = (event) => {
    this.setState({ copen: false });
  };

  render() {
    let { cycleLengthValue, isPeriodChange, isCycleChange } = this.state;
    let avgPeriodTextColor = isPeriodChange ? "#212529" : "#bfccdd";
    let cycleLengthTextColor = isCycleChange ? "#212529" : "#bfccdd";
    let currentmonthdays = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth(),
      0
    ).getDate();
    let prevmonthdays = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth() - 1,
      0
    ).getDate();
    let mindate = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth() - 1,
      1
    );
    let maxdate = prevmonthdays + currentmonthdays;
    return (
      <>
        <div className="calculator-field" data-test="last-period">
          <div className="field field-datepicker">
            <label>
              {this.state.dplabel}
              <a
                className="ttlink"
                alt={this.props.componentData.dateSelectionTooltip.value}
              >
                <i className="fa fa-question-circle"></i>
                <span>
                  {this.props.componentData.dateSelectionTooltip.value}
                </span>
              </a>
            </label>
            <DatePicker
              minDate={
                new Date(
                  this.state.currentDate.getFullYear(),
                  this.state.currentDate.getMonth() - 1,
                  1
                )
              }
              maxDate={new Date()}
              locale="enIN"
              dateFormat="dd MMMM, yyyy"
              showPopperArrow={false}
              selected={this.state.startDate}
              onChange={(date) => this.changeDate(date)}
              customInput={
                <Customdatepicker
                  imagepath={this.state.lastPeriodDateLogo}
                  placeholder="Select a date"
                />
              }
              showPreviousMonths={this.state.copen ? true : false}
              placeholderText="Select a date"
            ></DatePicker>
          </div>
        </div>

        <div className="duration-wrap">
          <label>
            {this.props.componentData.durationSelection1Label.value}
            <a
              className="ttlink"
              alt={this.props.componentData.durationSelection1Tooltip.value}
            >
              <i className="fa fa-question-circle"></i>
              <span>
                {this.props.componentData.durationSelection1Tooltip.value}
              </span>
            </a>
          </label>
          <div className="input-group">
            <input
              type="button"
              value="-"
              className="button-minus"
              data-field="quantity"
              onClick={this.decreasePeriod}
              disabled={this.state.periodDuration === 1}
            />
            <input
              type="text"
              id="avg-period-duration"
              readOnly
              placeholder="select Period"
              name="avg-period-duration"
              className={this.state.showPlus ? "avg-period-duration" : ""}
              onClick={this.togglePeriodDays}
              value={`${this.state.periodDuration}`}
              style={
                this.props.currentMonthCycle.periodDuration !== 0
                  ? { color: "#424C5F" }
                  : { color: avgPeriodTextColor }
              }
            />
            <input
              type="button"
              value="+"
              className="button-plus"
              data-field="quantity"
              onClick={this.increasePeriod}
              disabled={this.state.periodDuration === 10}
            />
          </div>
        </div>

        <div className="duration-wrap">
          <label>
            {this.props.componentData.durationSelection2Label.value}
            <a
              className="ttlink"
              alt={this.props.componentData.durationSelection2Tooltip.value}
            >
              <i className="fa fa-question-circle"></i>
              <span>
                {this.props.componentData.durationSelection2Tooltip.value}
              </span>
            </a>
          </label>
          <div className="input-group">
            <input
              type="button"
              value="-"
              className="button-minus"
              data-field="quantity"
              onClick={this.decreaseCycle}
              disabled={this.state.cycleLengthValue === 21}
            />
            <input
              type="text"
              id="period-cycle-length"
              readOnly
              className="period-cycle-range"
              value={`${cycleLengthValue}`}
              style={
                this.props.currentMonthCycle.cycleLength !== 0
                  ? { color: "#424C5F" }
                  : { color: cycleLengthTextColor }
              }
            />
            <input
              type="button"
              value="+"
              className="button-plus"
              data-field="quantity"
              onClick={this.increaseCycle}
              disabled={this.state.cycleLengthValue === 38}
            />
          </div>
        </div>

        <div className="future-dates-mini-form">
          <div className="calculator-field" data-test="last-period">
            <div className="field field-datepicker">
              <label>
                {this.props.componentData.futureDateSelectionLabel.value}
                <a
                  className="ttlink"
                  alt={
                    this.props.componentData.futureDateSelectionTooltip.value
                  }
                >
                  <i className="fa fa-question-circle"></i>
                  <span>
                    {this.props.componentData.futureDateSelectionTooltip.value}
                  </span>
                </a>
              </label>
              {this.props.selectedEvent === "multi" && (
                <label>{this.props.componentData.fromDateLabel.value}</label>
              )}
              <DatePicker
                locale="enIN"
                minDate={
                  new Date(
                    this.state.currentDate.getFullYear(),
                    this.state.currentDate.getMonth(),
                    this.state.currentDate.getDate() + 1
                  )
                }
                // maxDate={addDays(new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 1), maxdate)}
                maxDate={
                  new Date(
                    this.state.currentDate.getFullYear(),
                    this.state.currentDate.getMonth() + 11,
                    new Date(
                      this.state.currentDate.getFullYear(),
                      this.state.currentDate.getMonth(),
                      0
                    ).getDate()
                  )
                }
                dateFormat="dd MMMM, yyyy"
                showPopperArrow={false}
                selected={this.state.fromFutureDate}
                onChange={(date) => this.changeFromStartDate(date)}
                customInput={
                  <Customdatepicker
                    imagepath={this.state.lastPeriodDateLogo}
                    placeholder="Select a date"
                  />
                }
                showPreviousMonths={this.state.copen ? true : false}
                placeholderText="Select a date"
              ></DatePicker>
            </div>
          </div>

          {this.props.selectedEvent === "multi" && (
            <div className="calculator-field" data-test="last-period">
              <div className="field field-datepicker to-date">
                {!isMobile && (
                  <label className="hide-to-date-label">
                    {this.props.componentData.toDateLabel.value}
                  </label>
                )}
                <label>{this.props.componentData.toDateLabel.value}</label>
                <DatePicker
                  locale="en-IN"
                  minDate={
                    new Date(
                      new Date(this.state.fromFutureDate).getFullYear(),
                      new Date(this.state.fromFutureDate).getMonth(),
                      new Date(this.state.fromFutureDate).getDate() + 1
                    )
                  }
                  // maxDate={addDays(new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 1), maxdate)}
                  maxDate={
                    new Date(
                      new Date(this.state.fromFutureDate).getFullYear(),
                      new Date(this.state.fromFutureDate).getMonth() + 2,
                      new Date(this.state.fromFutureDate).getDate() + 1
                    )
                  }
                  dateFormat="dd MMMM, yyyy"
                  showPopperArrow={false}
                  selected={this.state.fromFutureEndDate}
                  onChange={(date) => this.changeFromEndDate(date)}
                  customInput={
                    <Customdatepicker
                      imagepath={this.state.lastPeriodDateLogo}
                      placeholder="Select a date"
                    />
                  }
                  showPreviousMonths={this.state.copen ? true : false}
                  placeholderText="Select a date"
                ></DatePicker>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default withTranslation()(FutureDateLastPeriodData);
